module.exports = __webpack_public_path__ + "header_orange_bg.png?1b558e5f8c2de32912bb17f6fee34f64";


//////////////////
// WEBPACK FOOTER
// ./src/assets/header_orange_bg.png
// module id = 565
// module chunks = 0